<div *ngIf="vendor; else loading" class="container mt-5">
  <div class="grid">
    <div class="col" style="display: flex; justify-content: start; " *ngIf="isAuditorApprovalForChange">
      <!-- <p-button (click)="approvedVendor()" label="Approve Selected Vendors" [outlined]="true"></p-button> -->
      <p-button pRipple label="Summary" icon="pi pi-eye" class="mr-2" 
        (click)="openSummaryDialog()"></p-button>
    </div>
    <div class="col" style="display: flex; justify-content: end; " *ngIf="isVendorStatus">
      <p-button pRipple label="Approve" icon="pi pi-check" class="mr-2" severity="success"
        (click)="openConfirmationDialog()" [disabled]="!selectedVendorList || !selectedVendorList.length"></p-button>
      <p-button pRipple label="Reject" icon="pi pi-times" class="mr-2" severity="danger" (click)="openRejectDialog()"
        [disabled]="!selectedVendorList || !selectedVendorList.length"></p-button>
    </div>
  </div>
 
  <div class="d-flex flex-wrap justify-content-center">
    <div class="text-center mb-5">
      <h1 class="custom-tag" [ngClass]="getSeverityClass(getSeverity(vendor.status))" style="text-align: center">
        {{headerStatus}}</h1>
      <img *ngIf="vendor.propertiery_img" [src]="FRAPPE_API_URL + vendor.propertiery_img" class="vendor-image"
        width="250px">
      <img *ngIf="!vendor.propertiery_img || vendor.propertiery_img === ''"
        src="https://netmat.in/demo/vendor/img/user.png" alt="{{ vendor.business_name }}"
        style="width: 150px; border-radius: 75px; border: solid 2px orange;">
      <h4 class="card-title" style="color: black;"><strong><u>{{vendor.business_name}}</u></strong></h4>
    </div>
    <div class="flex-grow-1 mb-5 d-flex justify-content-between">
      <p-accordion>

        <p-accordionTab header="General Information" [selected]="true">
          <table class="mb-5">
            <tr>
              <td><strong>Vendor Code:</strong></td>
              <td>{{vendor.vendor_code}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Company Title:</strong></td>
              <td>{{vendor.company_title}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Short Name:</strong></td>
              <td>{{vendor.short_name}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Business Name:</strong></td>
              <td>{{vendor.business_name}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Status:</strong></td>
              <td>{{vendor.status}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Plant:</strong></td>
              <td>{{vendor.plant}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Vendor Type:</strong></td>
              <td>{{vendor.vendor_type}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Industry Type:</strong></td>
              <td>{{vendor.select_industry_type}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Ministry Of Corporate Affairs(MCA):</strong></td>
              <td>{{vendor.ministry_of_corporate_affairsmca}}</td>
              <td *ngIf="mca_doc"><strong>MCA FILE</strong></td>
              <td *ngIf="mca_doc">
                <button pButton class="btn btn-primary" (click)="downloadFile(mca_doc)">
                  <i class="pi pi-download"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td><strong>MCA Number:</strong></td>
              <td>{{vendor.mca_number}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td *ngIf="profile_doc"><strong>Profile Photo:</strong></td>
              <td *ngIf="profile_doc">
                <button pButton class="btn btn-primary" (click)="downloadFile(profile_doc)">
                  <i class="pi pi-download"></i>
                </button>
              </td>
              <td></td>
              <td></td>
            </tr>
          </table>
          <p-accordion>
            <p-accordionTab header="Primary Address">
              <table class="mb-5">
                <tr>
                  <td><strong>Address Title:</strong></td>
                  <td>{{vendor.primary_address.address_title}}</td>
                </tr>
                <tr>
                  <td><strong>Address Type:</strong></td>
                  <td>{{vendor.primary_address.address_type}}</td>
                </tr>
                <tr>
                  <td><strong>Street / House Number:</strong></td>
                  <td>{{vendor.primary_address.address_line_1}}</td>
                </tr>
                <tr>
                  <td><strong>District:</strong></td>
                  <td>{{vendor.primary_address.address_line_2}}</td>
                </tr>
                <!-- <tr>
                  <td><strong>Email Address:</strong></td>
                  <td>{{vendor.primary_address.email_address}}</td>
                </tr> -->
                <tr>
                  <td><strong>Fax:</strong></td>
                  <td>{{vendor.primary_address.fax}}</td>
                </tr>
                <tr>
                  <td><strong>City:</strong></td>
                  <td> {{vendor.primary_address.city}}</td>
                </tr>
                <tr>
                  <td><strong>Country:</strong> </td>
                  <td>{{vendor.primary_address.country}}</td>
                </tr>
                <!-- <tr>
                  <td><strong>Phone No:</strong> </td>
                  <td>{{vendor.primary_address.phone_no}}</td>
                </tr> -->
                <tr>
                  <td><strong>Postal Code:</strong></td>
                  <td> {{vendor.primary_address.postal_code}} </td>
                </tr>
                <tr>
                  <td><strong>State/Province:</strong> </td>
                  <td>{{vendor.primary_address.state1}}</td>
                </tr>
              </table>
            </p-accordionTab>
            <p-accordionTab header="Bank Detail">
              <table class="mb-5">
                <tr>
                  <td><strong>Account Holder/Registered Name:</strong> </td>
                  <td>{{vendor.primary_address.bank_detail.account_holder__registered_name}}</td>
                </tr>
                <tr>
                  <td><strong>Account No:</strong> </td>
                  <td>{{vendor.primary_address.bank_detail.account_no}}</td>
                </tr>
                <tr>
                  <td><strong>Bank Name:</strong> </td>
                  <td>{{vendor.primary_address.bank_detail.bank_name}}</td>
                </tr>
                <tr>
                  <td><strong>Bank Address:</strong> </td>
                  <td>{{vendor.primary_address.bank_detail.bank_address}}</td>
                </tr>
                <tr>
                  <td><strong>IFSC Code:</strong> </td>
                  <td>{{vendor.primary_address.bank_detail.ifsc_code}}</td>
                </tr>
                <tr>
                  <td><strong>Branch Name:</strong> </td>
                  <td>{{vendor.primary_address.bank_detail.branch_name}}</td>
                </tr>
                <tr>
                  <td><strong>Bank Region:</strong> </td>
                  <td>{{vendor.primary_address.bank_detail.bank_region}}</td>
                </tr>
                <tr>
                  <td><strong>Bank City:</strong> </td>
                  <td>{{vendor.primary_address.bank_detail.bank_city}}</td>
                </tr>
                <tr *ngIf="bank_doc">
                  <td><strong>Bank Document</strong></td>
                  <td>
                    <button pButton class="btn btn-primary" (click)="downloadFile(bank_doc)">
                      <i class="pi pi-download"></i>
                    </button>
                  </td>
                </tr>
              </table>
            </p-accordionTab>
            <p-accordionTab header="Contact Details">
              <p-table [value]="vm_contact_detail">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Name</th>
                    <th>Telephone</th>
                    <th>Email ID</th>
                    <th>Mobile Number</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-contact>
                  <tr>
                    <td>{{ contact.vm_name }}</td>
                    <td>{{ contact.telephone }}</td>
                    <td>{{ contact.email_id }}</td>
                    <td>{{ contact.mobile_phone }}</td>
                  </tr>
                </ng-template>
              </p-table>
              <!-- <table class="mb-5">
                <tr>
                  <td><strong>Name:</strong></td>
                  <td>{{vendor.primary_address.contact_person.name1}}</td>
                </tr>
                <tr>
                  <td><strong>Phone No:</strong></td>
                  <td>{{vendor.primary_address.contact_person.phone_no}}</td>
                </tr>
                <tr>
                  <td><strong>Mobile No:</strong> </td>
                  <td>{{vendor.primary_address.contact_person.mobile_no}}</td>
                </tr>
                <tr>
                  <td><strong>E Mail ID:</strong> </td>
                  <td>{{vendor.primary_address.contact_person.e_mail_id}}</td>
                </tr>
                <tr>
                  <td><strong>Website/ URL:</strong> </td>
                  <td>{{vendor.primary_address.contact_person.website_url}}</td>
                </tr>
                <tr>
                  <td><strong>Alternate Email Id:</strong> </td>
                  <td>{{vendor.primary_address.contact_person.alternate_email_id}}</td>
                </tr>
              </table> -->
            </p-accordionTab>
            <p-accordionTab header="Contact Persion">
              <p-table [value]="contact_persion">
                <ng-template pTemplate="header">
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Department</th>
                    <th>Function</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-contact>
                  <tr>
                    <td>{{ contact.first_name }}</td>
                    <td>{{ contact.last_name }}</td>
                    <td>{{ contact.rockman_contact_department }}</td>
                    <td>{{ contact.rockman_contact_function }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </p-accordionTab>
            <p-accordionTab header="Tax Details">
              <table class="mb-5">
                <tr>
                  <td><strong>GST Registered:</strong></td>
                  <td>{{vendor.gst_registered}}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>GSTN:</strong> </td>
                  <td>{{vendor.primary_address.tax_details.gstn}}</td>
                  <td *ngIf="gst_doc"><strong>GST FILE</strong></td>
                  <td *ngIf="gst_doc">
                    <button pButton class="btn btn-primary" (click)="downloadFile(gst_doc)">
                      <i class="pi pi-download"></i>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td><strong>VAT Registration Number:</strong></td>
                  <td> {{vendor.primary_address.tax_details.vat_registration_number}}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>Service Tax Registration Number:</strong></td>
                  <td>{{vendor.primary_address.tax_details.service_tax_registration_number}}</td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </p-accordionTab>
          </p-accordion>

          <!-- </div> -->
          <!-- <p-accordion>
            <p-accordionTab *ngFor="let address of vendor.other_address" [header]="'Other Address ' + address.idx">
              <p class="card-text"><strong>Get User:</strong> {{vendor.get_user}}</p>
            </p-accordionTab>
          </p-accordion> -->
        </p-accordionTab>
        <p-accordionTab header="Vendor Classification">
          <table class="mb-5">
            <tr>
              <td><strong>Vendor Classification:</strong> </td>
              <td>{{vendor.vendor_classification}}</td>
            </tr>
          </table>
        </p-accordionTab>
        <p-accordionTab header="Turn Over Details">
          <table class="mb-5">
            <tr>
              <td><strong>Financial Year {{vendor.financial_previous_year}} (In Lakhs):</strong> </td>
              <td>{{vendor.previous_year}}</td>
            </tr>
            <tr>
              <td><strong>Financial Year {{vendor.financial_one_year_before_previous_year}} (In Lakhs):</strong> </td>
              <td>{{vendor.one_year_before_previous_year}}</td>
            </tr>
            <tr>
              <td><strong>Financial Year {{vendor.financial_two_years_before_previous_year}} (In Lakhs):</strong></td>
              <td>{{vendor.two_years_before_previous_year}}</td>
            </tr>
          </table>
        </p-accordionTab>
        <p-accordionTab header="Legal Details">
          <table class="mb-5">
            <tr>
              <td></td>
              <td></td>
              <td><strong>Document Type</strong></td>
              <td><strong>Action</strong></td>
            </tr>
            <tr>
              <td><strong>Legal Name:</strong></td>
              <td> {{vendor.legal_name}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>PAN No:</strong> </td>
              <td>{{vendor.pan_no}}</td>
              <td *ngIf="pan_doc"><strong>Pan document</strong></td>
              <td *ngIf="pan_doc">
                <button pButton class="btn btn-primary" (click)="downloadFile(pan_doc)">
                  <i class="pi pi-download"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td><strong>CIN No:</strong></td>
              <td>{{vendor.cin_no}}</td>
              <td *ngIf="cin"><strong>CIN</strong></td>
              <td *ngIf="cin">
                <button pButton class="btn btn-primary" (click)="downloadFile(cin)">
                  <i class="pi pi-download"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td><strong>TIN No:</strong> </td>
              <td>{{vendor.tin_no}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>DIN NO:</strong> </td>
              <td>{{vendor.din_no}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>MSME No:</strong> </td>
              <td>{{vendor.msme_no}}</td>
              <td *ngIf="msme_doc"><strong>MSME Certificate</strong></td>
              <td *ngIf="msme_doc">
                <button pButton class="btn btn-primary" (click)="downloadFile(msme_doc)">
                  <i class="pi pi-download"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td><strong>Expiry year:</strong> </td>
              <td>{{vendor.msme_expiry_year}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>AADHAR No:</strong> </td>
              <td>{{vendor.aadhar_no}}</td>
              <td></td>
              <td></td>
            </tr>
            <tr *ngIf="company_registration_doc">
              <td></td>
              <td></td>
              <td><strong>Company Registration</strong></td>
              <td>
                <button pButton class="btn btn-primary" (click)="downloadFile(company_registration_doc)">
                  <i class="pi pi-download"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="self_declaration_by_vendor">
              <td></td>
              <td></td>
              <td><strong>Self Declaration By Vendor</strong></td>
              <td>
                <button pButton class="btn btn-primary" (click)="downloadFile(self_declaration_by_vendor)">
                  <i class="pi pi-download"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="other_doc">
              <td></td>
              <td></td>
              <td><strong>Other Documents</strong></td>
              <td>
                <button pButton class="btn btn-primary" (click)="downloadFile(other_doc)">
                  <i class="pi pi-download"></i>
                </button>
              </td>
            </tr>
          </table>
          <!-- <p-table [value]="legalDocuments">
            <ng-template pTemplate="header">
              <tr>
                <th>Document Type</th>
                <th>Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
              <tr *ngIf="document.file">
                <td>{{ document.name }}</td>
                <td>
                  <button pButton class="btn btn-primary" (click)="downloadFile(document.file)">
                    <i class="pi pi-download"></i>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table> -->

        </p-accordionTab>
        <p-accordionTab header="Documents as required in Evaluation sheet">
          <p-table [value]="documents">
            <ng-template pTemplate="header">
              <tr>
                <th>Document Type</th>
                <th>Document Name</th>
                <th>Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
              <ng-container *ngIf="document.file">
                <tr>
                  <td>{{ document.name }}</td>
                  <td>{{ document.document_name }}</td>
                  <td>
                    <button pButton class="btn btn-primary" (click)="downloadFile(document.file)">
                      <i class="pi pi-download"></i>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </ng-template>
          </p-table>
        </p-accordionTab>
        <p-accordionTab header="Thrid Party Score" *ngIf="!isVendor">
          <table class="mb-5">
            <tr>
              <td><strong>3rd Party Evaluated Score:</strong></td>
              <td> {{vendor.thrid_party_evaluated_score}}</td>
            </tr>
            <tr>
              <td><strong>3rd Party Risk Score:</strong> </td>
              <td>{{vendor.thrid_party_risk_score}}</td>
            </tr>
          </table>
          <p-table [value]="thridPartyScoreDocuments">
            <ng-template pTemplate="header">
              <tr>
                <td>Document Type</td>
                <th>Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
              <tr *ngIf="document.file">
                <td>{{ document.name }}</td>
                <td>
                  <button pButton class="btn btn-primary" (click)="downloadFile(document.file)">
                    <i class="pi pi-download"></i>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>

        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
  <div style="margin-bottom: 30px;"></div>

  <div class="mt-3">
    <button pButton type="button" label="Back" class="btn btn-primary mr-6" (click)="goBack()"></button>
  </div>
</div>

<ng-template #loading>
  <div class="text-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</ng-template>

<p-confirmDialog header="Confirm Approval" [visible]="isApproveDialog" [style]="{ 'width': '40%' }" [closable]="false">
  <ng-template pTemplate="message">
    <div class="grid mb-0">
      <div style="text-align: center" class="col-12">
        <strong>Are you sure you want to approve the selected vendors?</strong>
      </div>
      <div class="col-12" *ngIf="isPendingApproval1">
        <div class="grid" style="text-align: center;">
          <div class="col">
            <div class="row"><label><strong>Reconciliation Account</strong></label></div>
            <!-- <input
                pInputText
                [(ngModel)]="accountgroup" placeholder="Reconciliation Account (Required)" style="width: 100%;" required/>  -->
            <div class="row"><p-dropdown [options]="vendorPayableAccountsList" [(ngModel)]="accountgroup"
                placeholder="Reconciliation Account (Required)" optionLabel="code" optionValue="code" [required]="true"
                appendTo="body" styleClass="w-17rem" /></div>
          </div>
          <div class="col">
            <div class="row"><label><strong>Payment Term</strong></label></div>
            <div class="row"><p-dropdown [options]="paymentterm1" [(ngModel)]="paymentTerm"
                placeholder="Payment Term (Required)" optionLabel="payment_term_code" optionValue="payment_term_code"
                [required]="true" appendTo="body" styleClass="w-17rem" /></div>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="pendingreview">
        <div class="grid" style="text-align: center;">
          <div class="col">
            <div class="field col">
              <label htmlFor="MCAFILE"><strong>3rd Party Business Score Document</strong></label>
              <p-fileUpload mode="basic" name="uploadGstFile[]" accept="image/*,.pdf,.xls,.xlsx"
                [maxFileSize]="25000000" (onSelect)="onUploadFile($event,'thrid_party_business_score_doc')"
                chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" *ngIf="!thrid_party_business_score_doc" styleClass="w-17rem"></p-fileUpload>
              <div *ngIf="thrid_party_business_score_doc">
                <span>{{thrid_party_business_score_doc.name}}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelUpload('thrid_party_business_score_doc')"></button>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="field col">
              <label htmlFor="MCAFILE"><strong>3rd Party Evaluated Scorecard Document</strong></label>
              <p-fileUpload mode="basic" name="uploadGstFile[]" accept="image/*,.pdf,.xls,.xlsx"
                [maxFileSize]="25000000" (onSelect)="onUploadFile($event,'thrid_party_evaluated_scorecard_doc')"
                chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" *ngIf="!thrid_party_evaluated_scorecard_doc"
                styleClass="w-17rem"></p-fileUpload>
              <div *ngIf="thrid_party_evaluated_scorecard_doc">
                <span>{{thrid_party_evaluated_scorecard_doc.name}}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelUpload('thrid_party_evaluated_scorecard_doc')"></button>
              </div>
            </div>
          </div>
        </div>
        <div class="grid" style="text-align: center;">
          <div class="col">
            <label><strong>3rd Party Evaluated Score</strong></label>
            <!-- <input
              pInputText
              [(ngModel)]="accountgroup" placeholder="Reconciliation Account (Required)" style="width: 100%;" required/>  -->
            <p-dropdown [options]="scoreList" [(ngModel)]="evaluatedScore"
              placeholder="3rd Party Evaluated Score(Required)" [required]="true" appendTo="body"
              styleClass="w-17rem" />
          </div>
          <div class="col">
            <label><strong>3rd Party Risk Score</strong></label>
            <p-dropdown [options]="scoreList" [(ngModel)]="riskScore" placeholder="3rd Party Risk Score(Required)"
              [required]="true" appendTo="body" styleClass="w-17rem" />
          </div>

        </div>
      </div>
      <div class="col-12" *ngIf="isPendingApproval2">
        <div class="grid" style="text-align: center;">
          <div class="col">
            <div class="row"> <label><strong>With Holding Tax</strong></label></div>
            <div class="row">
              <p-dropdown [options]="withholdingtax1" [(ngModel)]="withholdingtax"
                placeholder="With Holding Tax (Required)" [style]="{'width': '50%','text-align':'start'}"
                optionLabel="label" optionValue="value" [required]="true" appendTo="body"
                (ngModelChange)="OnChangeWithholding($event)" />
            </div>

          </div>
        </div>
        <!--<div *ngIf="isWithHoldingTaxYes">

          <div class="col-12">
            <div class="grid">
              <div class="col">
                <label><strong> Name</strong></label>
                <p-dropdown [options]="reconciliationTypeList" [(ngModel)]="RectyData" optionLabel="description"
                  appendTo="body" styleClass="w-20rem" (ngModelChange)="OnChangeReconciliation($event)" />
              </div>
              <div class="col">
                <label><strong> Reconciliation type </strong></label>
                <input pInputText [(ngModel)]="reconciliationName" style="width: 100%;"  />
              </div>
              <div class="col-12">
                <div class="grid">
                  <div class="col">
                    <label><strong> Name</strong></label>
                    <p-dropdown [options]="withHoldingTaxTypeList" [(ngModel)]="Wthttype" optionLabel="description"
                      styleClass="w-20rem" appendTo="body" (ngModelChange)="OnChangeWithholdingTaxType($event)" />
                  </div>
                  <div class="col">
                    <label><strong> With Holding Tax Type </strong></label>
                    <input pInputText [(ngModel)]="WithHoldingTaxType" style="width: 100%;"  />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="grid">
                  <div class="col">
                    <label><strong> Name </strong></label>
                    <p-dropdown [options]="withHoldingTaxCode" [(ngModel)]="Wtaxcode" optionLabel="description"
                      appendTo="body" styleClass="w-20rem" (ngModelChange)="OnChangeWithholdingTaxCode($event)" />
                  </div>
                  <div class="col">
                    <label><strong> With Holding Tax Code </strong></label>
                    <input pInputText [(ngModel)]="WithHoldingTaxCodeName" style="width: 100%;"  />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="grid">
                  <div class="col">
                    <label><strong> Exemption Number </strong></label>
                    <input pInputText [(ngModel)]="ExemptionNumber" style="width: 100%;"  />
                  </div>
                  <div class="col">
                    <label><strong> Exem.%</strong></label>
                    <input pInputText [(ngModel)]="Exem" style="width: 100%;"  />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="grid">
                  <div class="col">
                    <label class="font-bold block mb-2"> Exempt From </label>
                    <p-calendar inputId="calendar-24h" [(ngModel)]="ExemptFrom" dateFormat="dd-mm-yy"
                      [style]="{'width': '100%'}" appendTo="body" [showIcon]="true" />
                  </div>
                  <div class="col">
                    <label class="font-bold block mb-2"> Exempt To </label>
                    <p-calendar inputId="calendar-24h" [(ngModel)]="ExemptTo" appendTo="body" dateFormat="dd-mm-yy"
                      [style]="{'width': '100%'}" [showIcon]="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end mt-0">
      <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="closeConfirmationDialog()"></button>
      <button type="button" pButton label="Approve" icon="pi pi-check" (click)="approvedVendor()"
        [disabled]="!isFormValid()"></button>
    </div>
  </ng-template>
</p-confirmDialog>


<p-sidebar [(visible)]="sidebarVisible" position="right" [style]="{ width: '65%' }" [showCloseIcon]="false">
  <div class="col-12" *ngIf="isPendingApproval2">

    <div style="display:flex;justify-content: end">
      <p-button pRipple icon="pi pi-times" severity="danger" (click)="oncloseHolding()"></p-button>
    </div>

    <!-- <div class="grid" style="text-align: center;"> -->
    <!-- <div class="col-8">
      <label class="font-bold block mb-2"> With Holding Tax <span class="required-asterisk">*</span></label>
      <p-dropdown [options]="withholdingtax1" [(ngModel)]="withholdingtax"
        [style]="{'width': '50%','text-align':'center'}"
        optionLabel="label" optionValue="value" appendTo="body"
        (ngModelChange)="OnChangeWithholding($event)" />
    </div>
    <div class="col-4" *ngIf="isApproved2">
      <p-button pRipple label="Approve" icon="pi pi-check" [style]="{'margin-top': '20px'}" severity="success"
              (click)="approvedVendor()"></p-button>
    </div> -->
    <!-- <div class="col">
         <p-dropdown
         [options]="withholdingtax1"
         [(ngModel)]="withholdingtax"
         placeholder="With Holding Tax (Required)"
         [style]="{'width': '50%','text-align':'start'}"
         optionLabel="label"
         optionValue="value"
         [required]="true"
         appendTo="body"
         />
  </div> -->
    <!-- </div> -->
    <div *ngIf="isWithHoldingTaxYes">

      <div class="col-12">
        <div class="grid">
          <div class="col">
            <label><strong> Name <span class="required-asterisk">*</span></strong></label>
            <p-dropdown [options]="withHoldingTaxTypeList" [(ngModel)]="Wthttype" optionLabel="description"
              styleClass="w-20rem" appendTo="body" (ngModelChange)="OnChangeWithholdingTaxType($event)" />
          </div>
          <div class="col">
            <label><strong> With Holding Tax Type <span class="required-asterisk">*</span></strong></label>
            <input pInputText [(ngModel)]="WithHoldingTaxType" style="width: 100%;" required />
          </div>
          <div class="col">
            <label><strong> Name<span class="required-asterisk">*</span></strong></label>
            <p-dropdown [options]="reconciliationTypeList" [(ngModel)]="RectyData" optionLabel="description"
              appendTo="body" styleClass="w-20rem" (ngModelChange)="OnChangeReconciliation($event)" />
          </div>
          <div class="col">
            <label><strong> Reconciliation type<span class="required-asterisk">*</span></strong></label>
            <input pInputText [(ngModel)]="reconciliationName" style="width: 100%;" required />
          </div>
          <!-- <div class="col-12">
          <div class="grid"> -->

          <!-- </div>
        </div> -->
          <div class="col-12">
            <div class="grid">
              <div class="col">
                <label><strong> Name <span class="required-asterisk">*</span></strong></label>
                <p-dropdown [options]="withHoldingTaxCode" [(ngModel)]="Wtaxcode" optionLabel="description"
                  appendTo="body" styleClass="w-20rem" (ngModelChange)="OnChangeWithholdingTaxCode($event)" />
              </div>
              <div class="col">
                <label><strong> With Holding Tax Code <span class="required-asterisk">*</span></strong></label>
                <input pInputText [(ngModel)]="WithHoldingTaxCodeName" style="width: 100%;" />
              </div>
              <div class="col">
                <label><strong> Exemption Number <span class="required-asterisk">*</span></strong></label>
                <input pInputText [(ngModel)]="ExemptionNumber" style="width: 100%;" />
              </div>
              <div class="col">
                <label><strong> Exem.%<span class="required-asterisk">*</span></strong></label>
                <input pInputText [(ngModel)]="Exem" style="width: 100%;" />
              </div>
            </div>
          </div>
          <!-- <div class="col-12">
          <div class="grid"> -->

          <!-- </div>
        </div> -->
          <div class="col-12">
            <div class="grid">
              <div class="col-3">
                <label class="font-bold block mb-2"> Exempt From <span class="required-asterisk">*</span></label>
                <p-calendar inputId="calendar-24h" [(ngModel)]="ExemptFrom" dateFormat="dd-mm-yy"
                  [style]="{'width': '100%'}" appendTo="body" [showIcon]="true" />
              </div>
              <div class="col-3">
                <label class="font-bold block mb-2"> Exempt To <span class="required-asterisk">*</span></label>
                <p-calendar inputId="calendar-24h" [(ngModel)]="ExemptTo" appendTo="body" dateFormat="dd-mm-yy"
                  [style]="{'width': '100%'}" [showIcon]="true" />
              </div>
              <div class="col-4">
                <p-button pRipple (click)="addWithholding()" [disabled]="!isFormValid()" icon="pi pi-plus"
                  [style]="{'margin-top': '25px','margin-left':'50px'}" label="Add"></p-button>
                <p-button pRipple label="Approve" icon="pi pi-check" class="ml-5" severity="success"
                  (click)="approvedVendor()" [disabled]="isApproved"></p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="withHoldingMultiData.length > 0">
    <p-table styleClass="p-datatable-sm" [value]="withHoldingMultiData" [tableStyle]="{ 'min-width': '50rem'}">
      <ng-template pTemplate="header">
        <tr>
          <th>Wth.t.type</th>
          <th>Name</th>
          <th>W/tax code</th>
          <th>Name</th>
          <th>Rec.ty</th>
          <th>Name</th>
          <th>Exemption Number</th>
          <th>Exem.%</th>
          <th>Exempt From</th>
          <th>Exempt To</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr>
          <td>{{ data.with_holding_tax_type }}</td>
          <td>{{ data.with_holding_tax_type_name }}</td>
          <td>{{ data.with_holding_tax_code }}</td>
          <td>{{ data.with_holding_tax_code_name }}</td>
          <td>{{ data.reconciliation_type }}</td>
          <td>{{ data.reconciliation_name }}</td>
          <td>{{ data.exemption_number }}</td>
          <td>{{ data.exem }}</td>
          <td>{{ data.exempt_from | date:'dd-MM-yy' }}</td>
          <td>{{ data.exempt_to | date:'dd-MM-yy' }}</td>
        </tr>
      </ng-template>
    </p-table><br><br>
  </div>
</p-sidebar>


<p-confirmDialog header="Confirm Rejection" [visible]="isRejectDialog" [style]="{ 'width': '40%' }" [closable]="false">
  <ng-template pTemplate="message">
    <div class="grid mb-0">
      <div style="text-align: center" class="col-12">
        <strong>Are you sure you want to reject the selected vendors?</strong>
      </div>
      <div class="col-12">
        <div class="grid" style="text-align: center;">
          <input pInputText [(ngModel)]="rejectReason" placeholder="Reject Reason(Required)" style="width: 100%;"
            required />
        </div>
      </div>
    </div>

  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end mt-0">
      <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="closeRejectDialog()"></button>
      <button type="button" pButton label="Reject" icon="pi pi-check" (click)="onReject()"
        [disabled]="!rejectReason"></button>
    </div>
  </ng-template>
</p-confirmDialog>


<p-confirmDialog header="Confirm" [visible]="pendingApprovalForDialog" [style]="{ 'width': '40%' }" [closable]="false">
  <ng-template pTemplate="message">
    <div class="grid mb-0">
      <div style="text-align: center" class="col-12">
        <strong>Are you sure you want to approve the selected vendor change request?</strong>
      </div>
    </div>

  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end mt-0">
      <button type="button" pButton label="Cancel" icon="pi pi-times"
        (click)="pendingApprovalForDialog = false"></button>
      <button type="button" pButton label="Approve" icon="pi pi-check" (click)="onApproveChangeRequest()"></button>
    </div>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog header="Confirm Rejection" [visible]="pendingRejectForDialog" [style]="{ 'width': '40%' }"
  [closable]="false">
  <ng-template pTemplate="message">
    <div class="grid mb-0">
      <div style="text-align: center" class="col-12">
        <strong>Are you sure you want to reject the selected vendor ?</strong>
      </div>
    </div>

  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end mt-0">
      <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="pendingRejectForDialog = false"></button>
      <button type="button" pButton label="Reject" icon="pi pi-check" (click)="onRejectChangeRequest()"></button>
    </div>
  </ng-template>
</p-confirmDialog>


<p-confirmDialog header="Summary Details" [visible]="isDialogSummary" [closable]="false" [style]="{ 'width': '35%' }">
  <ng-template pTemplate="message">
    <div style="overflow: hidden;">
      <p-table 
          [value]="getFilteredDetails()" 
          styleClass="p-datatable-gridlines" 
          [tableStyle]="{ 'min-width': '100%' }" 
          [scrollable]="true" 
          scrollHeight="400px">
        <ng-template pTemplate="header">
          <tr>
            <th style="text-align: center;">Field</th>
            <th style="text-align: center;">Old Detail</th>
            <th style="text-align: center;">New Detail</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-detail>
          <tr>
            <td>{{ getShortKey(detail.key) }}</td>
            <td>{{ detail.oldValue }}</td>
            <td>{{ detail.newValue }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end mt-0">
      <button type="button" pButton label="Cancel" icon="pi pi-times" (click)="isDialogSummary = false"></button>
    </div>
  </ng-template>
</p-confirmDialog>




<!-- <p-confirmDialog [style]="{ width: '450px' }" /> -->

<p-toast />

<!-- Loading Screen -->
<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>